export { ATMServicesDetails } from './ATMServicesDetails'
